import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-[#0a0a0a]" data-id="element-128">
      {/* Background texture overlay */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: `radial-gradient(ellipse at 20% 50%, #C0392B22 0%, transparent 60%),
                            radial-gradient(ellipse at 80% 50%, #1A527622 0%, transparent 60%)`
    }} data-id="element-129" />

      {/* Subtle grain texture */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E")`
    }} data-id="element-130" />

      <div className="relative z-10 max-w-6xl mx-auto px-6 py-20 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-131">
        {/* Left: Text */}
        <motion.div initial={{
        opacity: 0,
        x: -40
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.9,
        ease: 'easeOut'
      }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-132">
          {/* Flag bar */}
          <motion.div initial={{
          scaleX: 0
        }} animate={{
          scaleX: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flag-gradient h-1 w-24 mb-8 mx-auto lg:mx-0 origin-left" data-id="element-133" />

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3
        }} className="text-[#CF9B2E] uppercase tracking-[0.3em] text-sm font-bold mb-4 font-['Lato']" data-id="element-134">
            El libro que sacude conciencias
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} className="text-5xl md:text-6xl lg:text-7xl font-black leading-[1.05] mb-6 text-[#F5F0E8]" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-135">
            VENEZUELA
          </motion.h1>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55,
          duration: 0.8
        }} className="text-2xl md:text-3xl lg:text-4xl font-bold leading-tight mb-8 text-[#E8D5B0]" style={{
          fontFamily: 'Playfair Display, serif',
          fontStyle: 'italic'
        }} data-id="element-136">
            La verdad que el mundo
            <br data-id="element-137" />
            <span className="text-[#CF9B2E]" data-id="element-138">no quiso ver.</span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.7
        }} className="text-[#9A9080] text-lg md:text-xl leading-relaxed mb-10 max-w-lg mx-auto lg:mx-0" data-id="element-139">
            El relato definitivo de cómo un país rico en petróleo fue destruido
            desde adentro — y cómo su pueblo sobrevivió para contarlo.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.85
        }} className="flex flex-col items-center lg:items-start gap-4" data-id="element-140">
            <a href="https://templeofpages.com/cart/48590206533875:1" className="btn-primary inline-block px-10 py-5 text-lg rounded-sm font-bold tracking-widest" aria-label="Comprar el libro por 9,99 USD" data-id="element-141">
              Comprar por 9,99 USD
            </a>

            <div className="flex items-center gap-3 text-[#9A9080] text-sm" data-id="element-142">
              <ShieldCheckIcon className="w-4 h-4 text-[#CF9B2E]" data-id="element-143" />
              <span data-id="element-144">
                Pago seguro · Entrega inmediata · Garantía de devolución
              </span>
            </div>

            <div className="flex items-center gap-1 mt-1" data-id="element-145">
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-146" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-147" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-148" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-149" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-150" />
              <span className="text-[#9A9080] text-sm ml-2" data-id="element-151">
                +1,200 lectores en 18 países
              </span>
            </div>
          </motion.div>
        </motion.div>

        {/* Right: Book Cover */}
        <motion.div initial={{
        opacity: 0,
        x: 40,
        rotateY: -15
      }} animate={{
        opacity: 1,
        x: 0,
        rotateY: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: 'easeOut'
      }} className="flex justify-center order-1 lg:order-2" style={{
        perspective: '1000px'
      }} data-id="element-152">
          <div className="relative" data-id="element-153">
            {/* Glow effect behind book */}
            <div className="absolute inset-0 blur-3xl opacity-30 bg-gradient-to-br from-[#C0392B] via-[#CF9B2E] to-[#1A5276] scale-110 rounded-lg" data-id="element-154" />

            <motion.img src="https://cdn.magicpatterns.com/uploads/9LpcEy5LEuRSi5KzDaMBHb/Portada_definitiva.png" alt="Portada del libro Venezuela — La verdad que el mundo no quiso ver" className="relative z-10 w-64 md:w-80 lg:w-96 shadow-2xl rounded-sm" style={{
            boxShadow: '0 25px 60px rgba(0,0,0,0.8), -8px 8px 30px rgba(207,155,46,0.2)'
          }} whileHover={{
            scale: 1.03,
            rotateY: 5
          }} transition={{
            duration: 0.4
          }} data-id="element-155" />

            {/* Price badge */}
            <motion.div initial={{
            scale: 0,
            rotate: -15
          }} animate={{
            scale: 1,
            rotate: -12
          }} transition={{
            delay: 1.2,
            type: 'spring',
            stiffness: 200
          }} className="absolute -bottom-4 -right-4 z-20 bg-[#CF9B2E] text-[#0a0a0a] rounded-full w-24 h-24 flex flex-col items-center justify-center shadow-lg" data-id="element-156">
              <span className="font-bold text-[14px]" data-id="element-157">PDF A SOLO</span>
              <span className="text-lg font-black leading-none" data-id="element-158">$9,99</span>
            </motion.div>
          </div>
        </motion.div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#0a0a0a] to-transparent" data-id="element-159" />
    </section>;
}